const purchase = {
  namespaced: true,
  state: {
    categoryList: [],
  },
  mutations: {
    setCategoryList(state, val) {
      state.categoryList = val
    },
  },
  actions: {},
  getters: {
    getCategoryList(state) {
      return state.categoryList
    },
  },
}
export default purchase
